// extracted by mini-css-extract-plugin
module.exports = {"stakeBtn":"Stake_stakeBtn__fpXoA","icon":"Stake_icon__2wXy9","tooltip":"Stake_tooltip__3F3Nu","stakeBtnDisable":"Stake_stakeBtnDisable__mII15","stakeIcon":"Stake_stakeIcon__13LWF"};